import type { ConversationPriorityEnumKey } from '../../../core/api/generated/models/ConversationPriority';
import type { ConversationStatusEnumKey } from '../../../core/api/generated/models/ConversationStatus';
import type { MessageSenderGroup } from '../models/conversation-view.types';

/** PT-BR display labels for conversation status. Display only — never used in logic/comparisons. */
export const CONVERSATION_STATUS_LABELS: Record<ConversationStatusEnumKey, string> = {
  open: 'Aberta',
  pending: 'Pendente',
  agent: 'IA em atendimento',
  snoozed: 'Pausada',
  resolved: 'Resolvida',
  archived: 'Arquivada',
  channel_unavailable: 'Canal indisponível',
};

/** PT-BR display labels for conversation priority. Display only. */
export const CONVERSATION_PRIORITY_LABELS: Record<ConversationPriorityEnumKey, string> = {
  low: 'Baixa',
  normal: 'Normal',
  high: 'Alta',
  urgent: 'Urgente',
};

export function conversationStatusLabel(status: ConversationStatusEnumKey): string {
  return CONVERSATION_STATUS_LABELS[status];
}

export function conversationPriorityLabel(priority: ConversationPriorityEnumKey): string {
  return CONVERSATION_PRIORITY_LABELS[priority];
}

/**
 * PT-BR label for the sender of a quoted ("Responder") message shown above a bubble.
 * `contactName` is the current conversation's contact display name — a conversation has
 * exactly one contact, so any `contact`-authored message in it is that same person. Falls
 * back to the generic "Cliente" when the name isn't known/blank (never leaves it empty).
 */
export function quotedReplySenderLabel(sender: MessageSenderGroup | undefined, contactName?: string): string {
  if (sender === 'contact') return contactName?.trim() || 'Cliente';
  if (sender === 'agent') return 'Você';
  if (sender === 'system') return 'Sistema';
  return 'Mensagem';
}
